import React, { memo } from "react";
import { useTranslation } from "react-i18next";

interface CleanupSeparatorProps {
  onEdit?: () => void;
  canEdit?: boolean;
}

const CleanupSeparator: React.FC<CleanupSeparatorProps> = memo(({ onEdit, canEdit }) => {
  const { t } = useTranslation();
  
  return (
    <div className="cleanup-separator">
      <hr />
      <span>{t("cleanup.cleanupInformation")}</span>
      {canEdit && onEdit && (
        <button className="separator-edit-btn" onClick={onEdit} title="Edit cleanup">
          <img
            src={`${process.env.PUBLIC_URL}/images/edit_prod.png`}
            alt="Edit"
            className="separator-edit-icon"
          />
        </button>
      )}
    </div>
  );
});

CleanupSeparator.displayName = "CleanupSeparator";

export default CleanupSeparator;
